import {
  PROFIT_AND_LOSS_STATEMENT_DATA_FROM_DATE_RANGE_SENT,
  PROFIT_AND_LOSS_STATEMENT_DATA_FROM_DATE_RANGE_SUCCESS,
  PROFIT_AND_LOSS_STATEMENT_DATA_FROM_DATE_RANGE_ERROR,
} from "./actionType";

// Actions for profit and loss statement data from date range
export const profitAndLossStatementDataFromDateRangeSent = (dataRange) => ({
  type: PROFIT_AND_LOSS_STATEMENT_DATA_FROM_DATE_RANGE_SENT,
  payload: dataRange,
});

export const profitAndLossStatementDataFromDateRangeSuccess = (data) => ({
  type: PROFIT_AND_LOSS_STATEMENT_DATA_FROM_DATE_RANGE_SUCCESS,
  payload: data,
});

export const profitAndLossStatementDataFromDateRangeError = (error) => ({
  type: PROFIT_AND_LOSS_STATEMENT_DATA_FROM_DATE_RANGE_ERROR,
  payload: error,
});
